import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export const useInvisibleReCAPTCHA = () => {
  const [isExecuting, setIsExecuting] = useState<boolean>(false);
  const ref = useRef<ReCAPTCHA | undefined>();

  const executeAsync = async (): Promise<string> => {
    setIsExecuting(true);

    const promise =
      process.env.RAILS_ENV === "test"
        ? new Promise<string>((resolve) => resolve("dummy_token"))
        : ref.current.executeAsync();

    await promise;

    process.env.RAILS_ENV !== "test" && ref.current.reset();
    setIsExecuting(false);

    return promise;
  };

  return { isExecuting, ref, executeAsync };
};
